import { FormDataGroup } from 'src/types';

export const PartialDataMasInformacionConfigurador: Partial<FormDataGroup> = {
  headers: { DESC_FORMOBJECTIVE: 'Más Información' },
  fields: {
    formFields: {},
    formularioFlag: 'masInformacion',
    formName: 'lead-mas_informacion-configure',
    formType: 'contact',
    pageCategory: 'Más Información',
  },
};
